export const formationsData = [
  {
    "id": 1,
    "image": "/formations-images/Captura de tela de 2025-02-18 18-31-19.png",
    "modality": "Presencial",
    "date": "14-02-2025",
    "title": "Oficina ESG",
    "description": "Diretrizes e Oportunidades para Organizações Não Governamentais – ONGs",
    "fullTitle": "Oficina ESG: Diretrizes e Oportunidades para Organizações Não Governamentais – ONGs",
    "details": {
      "date": "14 de fevereiro de 2025 (sexta-feira)",
      "time": "14h às 18h",
      "workload": "4h",
      "location": "Escola de Administração - UFBA (Avenida Reitor Miguel Calmon s/n, Vale do Canela)"
    },
    "facilitators": ["Bárbara Said", "Paulo Lima"],
    "targetAudience": "Gestores, voluntários, estudantes das áreas de gestão, contabilidade e interessados em Organizações do Terceiro Setor.",
    "registration": {
      "period": "04/02 a 12/02/2025",
      "link": "https://bit.ly/3WPZaJp"
    },
    "extraInfo": "Não perca a chance de aprimorar seu conhecimento sobre ESG e fortalecer sua atuação no Terceiro Setor.",
    "programContent": [
      "Histórico, desenvolvimento e diretrizes do ESG",
      "Práticas ESG contemporâneas",
      "Sustentabilidade e ESG",
      "Responsabilidade Corporativa",
      "Leis de incentivo fiscal",
      "Ambiente de Gestão nas organizações do Terceiro Setor",
      "Normas e legislações essenciais no Terceiro Setor",
      "Noções de projetos de captação",
      "Parcerias e captação de recursos por ONGs"
    ]
  },
  {
    "id": 2,
    "image": "/formations-images/Captura de tela de 2025-02-18 18-34-39.png",
    "modality": "Online",
    "date": "18-02-2025 à 21-02-2025",
    "title": "Desenvolvimento de API com Python e Django Rest Framework",
    "description": null,
    "fullTitle": "Desenvolvimento de API com Python e Django Rest Framework",
    "details": {
      "date": "18 a 21 de fevereiro de 2025",
      "time": "17 horas",
      "workload": "4h",
      "location": "Online"
    },
    "facilitators": ["Anderson Silva Brito", "Anderson Passos Silva", "Arlindo Neto"],
    "targetAudience": null,
    "registration": {
      "period": "Até 16 de fevereiro de 2025",
      "link": "https://bit.ly/3CDbw0M"
    },
    "extraInfo": "Aprenda como desenvolver APIs robustas, seguras e escaláveis com um dos frameworks mais utilizados no mercado, o Django Rest Framework. Não perca a oportunidade de melhorar suas habilidades e impulsionar sua carreira como desenvolvedor!",
    "programContent": [] // Pode ser um array vazio se não houver conteúdo programático explícito
  },
  {
    "id": 3,
    "image": "/formations-images/Captura de tela de 2025-02-18 18-35-57.png",
    "modality": "Online",
    "date": "25-02-2025 à 26-02-2025",
    "title": "Criando Página Inicial de uma Joalheria com HTML e CSS",
    "description": null,
    "fullTitle": "Criando Página Inicial de uma Joalheria com HTML e CSS",
    "details": {
      "date": "25 e 26 de fevereiro de 2025",
      "time": "17 horas",
      "workload": "4h",
      "location": "Online"
    },
    "facilitators": ["Maria Alice", "Dênerson Pinas"],
    "targetAudience": null,
    "registration": {
      "period": "Até 23 de fevereiro de 2025",
      "link": "https://bit.ly/4aKtSt7"
    },
    "extraInfo": "Quer melhorar suas habilidades de desenvolvimento com HTML e CSS?\nParticipe do curso \"Criando Página Inicial de uma Joalheria com HTML e CSS\" e aprenda os fundamentos do desenvolvimento web!",
    "programContent": []
  },
  {
    "id": 4,
    "image": "/formations-images/Captura de tela de 2025-02-18 18-45-18.png",
    "modality": "Online",
    "date": "19-02-2025",
    "title": "Conceitos Básicos de Design e Introdução ao Figma",
    "description": null,
    "fullTitle": "Conceitos Básicos de Design e Introdução ao Figma",
    "details": {
      "date": "19 de fevereiro de 2025",
      "time": "17 horas",
      "workload": "4h",
      "location": "Online"
    },
    "facilitators": ["Gustavo Ferreira", "Dênerson Pinas"],
    "targetAudience": null,
    "registration": {
      "period": "Até 17 de fevereiro de 2025",
      "link": "https://bit.ly/42FozsW"
    },
    "extraInfo": "Quer aprender sobre design e dar os primeiros passos no Figma?\nO Programa Nubank de Parceria com a UFBA e o IFBA em parceria com o Diretório Acadêmico de Administração (DAADM) irá ministrar o curso \"Conceitos Básicos de Design e Introdução ao Figma\"!",
    "programContent": []
  }
];